module.exports = __webpack_public_path__ + "static/media/Bird.b39bb247.png";